import ApplicationController from "./application_controller";
import {
  searchInputHtml,
  restorePersistedFilterState,
  updateFilterCounts,
  persistFolderState,
  persistAttachmentsVisible,
} from "./documents/filter";
import {
  insertTable,
  dataTableColumns,
  localStorageStateKey,
} from "./documents/table";
import { setLink, htmlEscape, safeCssClass } from "./utils";

let searchKeywords = false;

window.DataTable.ext.type.search["document-keywords"] = function (data) {
  if (!data) {
    return "";
  }
  return searchKeywords ? data : "";
};

const rowActions = [
  "contextmenu->document-list#contextMenuFromClick",
  "dragstart->document-list#documentDragStart",
  "dragend->document-list#documentDragEnd",
].join(" ");

export default class extends ApplicationController {
  static outlets = ["document-menu", "folders"];
  static values = {
    initialUrl: String,
    initialWithAttachmentsUrl: String,
    tabId: String,
    caseId: String,
  };

  static targets = [
    "table",
    "filter",
    "attachments",
    "attachmentsInput",
    "filterFolderInput",
    "folder",
  ];

  connect() {
    this.insertV10FoldersTemplate();
    const tab = document.getElementById(this.tabIdValue);
    if (tab && tab.classList.contains("active")) {
      this.refresh();
    }
  }

  disconnect() {}

  // triggered when switching to document tab (showDocuments function
  // generated by getCaseManagementInterface in Query.java)
  refresh() {
    if (!this.hasTableTarget) {
      insertTable();
    }
    this.filterFolderId = restorePersistedFilterState(this.caseIdValue, {
      attachmentsInputTarget: this.attachmentsInputTarget,
      filterFolderInputTarget: this.filterFolderInputTarget,
      foldersOutlet: this.foldersOutlet,
    });

    if (!$.fn.DataTable.isDataTable("#casedocuments")) {
      this.dataTable = $jQuery("#casedocuments").DataTable({
        layout: {
          topStart: [
            {
              search: {
                placeholder: "Filter",
              },
            },
            document
              .getElementById("document-category-filter-tpl")
              .content.cloneNode(true),
            document
              .getElementById("document-filter-dropdown-tpl")
              .content.cloneNode(true),
          ],
          topEnd: {
            buttons: [
              {
                extend: "colvis",
                fade: 0,
                columns: [
                  "category:name",
                  toggles.files.showSourceColumn && "source:name",
                  "documentId:name",
                  "documentType:name",
                  "iconClass:name",
                  "documentName:name",
                  "iconUrl:name",
                  "tags:name",
                  "uploadTime:name",
                  "deletedAt:name",
                  "purgeOn:name",
                  "emailFrom:name",
                  "emailTo:name",
                  "uploadedBy:name",
                  "timelineDate:name",
                  "inSummary:name",
                  "public:name",
                  "redactedVersionId:name",
                  "notes:name",
                ].filter(Boolean),
              },
            ],
          },
        },
        columns: dataTableColumns(this),
        searching: true,
        stateSave: true,
        stateDuration: 0,
		stateSaveParams: (settings, data) => {
		  data.search.search = "";
		  data.start = 0;

		  const forceShowPublicColumn =
		    this.config?.showPublicDocumentColumn === true ||
		    this.config?.showPublicDocumentColumn === "true";

		  if (!forceShowPublicColumn) {
		    return;
		  }

		  const publicColumnIndex = this.dataTable
		    ?.column("public:name")
		    ?.index();

		  if (publicColumnIndex == null || publicColumnIndex < 0) {
		    return;
		  }

		  const savedState = JSON.parse(
		    localStorage.getItem(localStorageStateKey(settings)) || "{}"
		  );

		  if (savedState?.columns?.[publicColumnIndex]) {
		    data.columns[publicColumnIndex].visible =
		      savedState.columns[publicColumnIndex].visible;
		  }
		},
        stateSaveCallback: function (settings, data) {
          try {
            localStorage.setItem(
              localStorageStateKey(settings),
              JSON.stringify(data),
            );
          } catch (e) {
            // noop
          }
        },
        stateLoadCallback: function (settings) {
          try {
            return JSON.parse(
              localStorage.getItem(localStorageStateKey(settings)),
            );
          } catch (e) {
            return {};
          }
        },
        responsive: {
          details: {
            type: "column",
            target: 1,
          },
        },
        select: {
          style: "os",
        },
        paging: true,
        pageLength: 100,
        info: false,
        ordering: true,
        order: [[4, "desc"]],
        language: {
          search: searchInputHtml(),
        },
        createdRow: (row, data, dataIndex) => {
          row.draggable = true;
          row.dataset.action = rowActions;
          row.dataset.documentListIdParam = this.documentIdToParam(
            data["documentId"],
          );
        },
        ajax: (data, callback, settings) => {
          $.ajax({
            url: this.filterUrl(),
            contentType: "application/json",
            dataType: "json",
            method: "GET",
            error: function (data) {
              console.log("Error! Could not retrieve the data.");
              $(".fooicon-loader").remove();
              $(".footable-loader").append("<p>Error retrieving documents</p>");
              return {};
            },
          }).then((data) => {
            if (data != null) {
              $.fn.dataTable.moment(
                data.config.dateFormat.toUpperCase() + " HH:mm:ss",
              );
              this.documents = data.documents;
              this.counts = data.counts;
              this.filterState = data.filter;
              this.config = data.config;
              this.links = data.links;
			  this.allDocuments = data.documents;
			  this.topLevelDocuments = data.documents.filter(d => !d.emailAttachment);
			  // for attachment lookup / expansion
			  this.attachmentsByTxn = this.indexAttachmentsByTransactionId(this.allDocuments);
			  const enhancedThreadingEnabled = !!data.config?.useEnhancedEmailThreading;

			  // hide legacy checkbox label
			  const label = document.querySelector('label[for="attachmentsCheckbox"]');
			  if (label) label.style.display = enhancedThreadingEnabled ? "none" : "";

			  // force attachments ON when enhanced threading is enabled
			  if (enhancedThreadingEnabled && this.hasAttachmentsInputTarget && !this.attachmentsInputTarget.checked) {
			    this.attachmentsInputTarget.checked = true;
			    persistAttachmentsVisible(this.caseIdValue, true);
			    this.dataTable.ajax.reload(null, false);
			    return;
			  }

			  // show/hide the chevron column based on the flag
			  this.dataTable.column("attachmentChevron:name").visible(enhancedThreadingEnabled);
			  this.dataTable.column("attachmentCount:name").visible(enhancedThreadingEnabled);

			  let rows = data.documents;

			  if (enhancedThreadingEnabled) {
			    this.attachmentsByTxn = this.indexAttachmentsByTransactionId(rows);
			    rows = rows.filter(d => !d.emailAttachment);
			  }

			  callback({ data: rows });

			  // paging size
			  const size = Number(data.config?.dataPagingSize);
			  if (Number.isFinite(size) && size > 0) {
			    this.dataTable.page.len(size).draw(false);
			  }			  			 
            } else {
              console.log("Error! Could not retrieve the data.");
              $(".fooicon-loader").remove();
              $(".footable-loader").append("<p>Error retrieving documents</p>");
            }
            this.enableNewDocumentLink();
            updateFilterCounts(this.counts, {
              filterTargets: this.filterTargets,
              attachmentsTarget: this.attachmentsTarget,
            });
            this.makePublicColumnVisible();	
            this.updateCategoryFilterList();
            this.makeThumbnailColumnVisible();
          });
        },
        headerCallback: function (thead, data, start, end, display) {
          const actionsColumn = thead.querySelector(".th-actions");
          const rowControlColumn = thead.querySelector(".th-control");
          const actionsIcon = `<span id="actions-icn" 
                                      class="fa fa-ellipsis-v fa-lg" 
                                      tabindex="0"
                                      role="region"
                                      title="Row actions" 
                                      data-toggle-thicon="tooltip" 
                                      data-placement="left" 
                                      data-boudnary="viewport"></span>
                                      <span class="sr-only">Row actions</span>`;

          const rowControlText = `<span class="sr-only" id="dt=contorl-clm">Row control</span>`;

          const isActionIcon = document.getElementById("actions-icn");
          const isRowControlText = document.getElementById("dr-control-clm");
          if (!isActionIcon) {
            actionsColumn.insertAdjacentHTML("beforeend", actionsIcon);
            $('[data-toggle-thicon="tooltip"]').tooltip();
          }
          // Trigger when column visibility changes
		  $('#casedocuments')
		    .off('column-visibility.dt.doctype')
		    .on('column-visibility.dt.doctype', (e, settings, column, state) => {
                let table = $('#casedocuments').DataTable();
                // Get the index of the "Type" column dynamically
                let typeColumnIndex = table.column(':contains("Type")').index();
                 if (column === typeColumnIndex && state) { // When 'Type' column is shown
                     insertDoctypeIcon(); // Call function to insert icon
                 }
             });
          if (!isRowControlText) {
            rowControlColumn.insertAdjacentHTML("beforeend", rowControlText);
          }
        },
      });
	  this.bindHybridSearchMode();
	  this.bindAttachmentChildRowHandlers();
      this.addCheckboxToggleOverride();	  
    } else {
      this.refreshDataTableContent();
    }
    // Trigger when DataTable initializes
    $("#casedocuments").on("init.dt", function () {
      let table = $("#casedocuments").DataTable();
      let isTypeVisible = table.column("iconClass:name").visible(); // Check if Column Type is visible

      if (isTypeVisible) {
        insertDoctypeIcon(); // Call function to insert icon
      }
    });

    function insertDoctypeIcon() {
      let doctypeColumn = document.querySelector(".th-doctype");
      if (doctypeColumn && !doctypeColumn.querySelector("#doctype-icn")) {
        doctypeColumn.insertAdjacentHTML(
          "beforeend",
          `<span id="doctype-icn"
                  class="fa fa-file-o fa-lg"
                  tabindex="0"
                  role="region"
                  title="Document type"
                  data-toggle-thicon="tooltip"
                  data-placement="top"
                  data-boudnary="viewport"></span>
                  <span class="sr-only">Document type</span>`,
        );
        $('[data-toggle-thicon="tooltip"]').tooltip();
      }
    }

    if (this.folderPanelVisible) {
      if (this.filterFolderId != null) {
        this.foldersOutlet.selectFolder(this.filterFolderId);
      }
      this.showTheFolderView();
    }
  }

  addCheckboxToggleOverride() {
    this.dataTable.on(
      "user-select",
      function (e, dataTable, type, cell, { target }) {
        if (
          target.nodeName.toLowerCase() === "input" &&
          target.classList.contains("dt-select-checkbox")
        ) {
          const row = dataTable.row(cell.node());
          if (row.selected()) {
            row.deselect();
          } else {
            row.select();
          }
          e.preventDefault();
        }
      },
    );
  }

  contextMenuFromClick(e) {
    const clickedDocumentId = this.documentIdFromParam(e.params.id);
    let selectedRows = this.dataTable.rows({ selected: true });
    let selectedDocuments = selectedRows.data();
    if (!selectedDocuments.pluck("documentId").includes(clickedDocumentId)) {
      this.selectOneDocument(clickedDocumentId);
      selectedRows = this.dataTable.rows({ selected: true });
      selectedDocuments = selectedRows.data();
    }
    if (selectedRows.count() == 1) {
      this.documentMenuOutlet.singleDocument(
        this.documentById(clickedDocumentId),
        this.config,
      );
    } else {
      this.documentMenuOutlet.multipleDocuments(
        selectedDocuments.toArray(),
        this.config,
      );
    }
    this.documentMenuOutlet.showNearEventPoint(e, e.timeStamp);
    e.preventDefault();
    e.stopPropagation();
  }

  documentDragStart(event) {
    const clickedDocumentId = this.documentIdFromParam(event.params.id);
    let selectedRows = this.dataTable.rows({ selected: true });
    let selectedDocuments = selectedRows.data();
    if (!selectedDocuments.pluck("documentId").includes(clickedDocumentId)) {
      this.selectOneDocument(clickedDocumentId);
      selectedRows = this.dataTable.rows({ selected: true });
      selectedDocuments = selectedRows.data();
    }
    event.dataTransfer.setData(
      "documentIds",
      JSON.stringify(selectedDocuments.pluck("documentId").toArray()),
    );
    event.dataTransfer.setData(
      "documentTypes",
      JSON.stringify(
        selectedDocuments
          .pluck("bundle")
          .map((isBundle) => (isBundle ? "bundle" : "document"))
          .toArray(),
      ),
    );
    event.dataTransfer.effectAllowed = "move";
    this.foldersOutlet.activateDocumentDropTargets(true);
  }

  documentDragOverFolder(event) {
    event.preventDefault();
    if (event.dataTransfer.effectAllowed === "all") {
      event.dataTransfer.dropEffect = "none";
      return false;
    }
    return true;
  }

  documentDragEnterFolder(event) {
    event.preventDefault();
    this.foldersOutlet.activateDocumentDropTarget(event.target, true);
    return true;
  }

  documentDragLeaveFolder(event) {
    event.preventDefault();
    this.foldersOutlet.activateDocumentDropTarget(event.target, false);
    return true;
  }

  makeThumbnailColumnVisible() {
    if (this.config.hideThumbnailColumn) {
      this.dataTable.column("iconUrl:name").visible(false);
    } else {
      this.dataTable.column("iconUrl:name").visible(true);
    }
  }

  async documentDrop(event) {
    this.foldersOutlet.activateDocumentDropTarget(event.target, false);
    let documentIds = JSON.parse(
      event.dataTransfer.getData("documentIds") || "[]",
    );
    let documentTypes = JSON.parse(
      event.dataTransfer.getData("documentTypes") || "[]",
    );
    if (documentIds.length == 0 || documentIds.length != documentTypes.length) {
      return false;
    }
    const targetFolderId = event.params.folderId;
    if (targetFolderId === this.filterFolderId) {
      return false;
    }
    for (let i = 0; i < documentIds.length; i++) {
      await this.foldersOutlet.addDocumentToFolder(
        targetFolderId,
        documentIds[i],
        documentTypes[i],
      );
    }
    this.foldersOutlet.activateDocumentDropTargets(false);
    this.refreshDataTableContent();
    window.parent.scrollTo(0, 0);
  }

  documentDragEnd(event) {
    event.preventDefault();
    this.foldersOutlet.activateDocumentDropTargets(false);
    return true;
  }

  documentById(documentId) {
    return this.documents.find(
      (document) => document.documentId === documentId,
    );
  }

  documentIdToParam(documentId) {
    return `doc-${documentId}`;
  }

  documentIdFromParam(idParam) {
    return idParam.replace(/^doc-/, "");
  }

  selectOneDocument(document) {
    const documentParam = this.documentIdToParam(document);
    this.dataTable.rows({ selected: true }).deselect();
    this.dataTable
      .row(`[data-document-list-id-param='${documentParam}']`)
      .select();
  }

  showTheFolderView() {
    document.getElementById("sidepanel").classList.remove("d-none");
    changeIcon();
    let table = $("#casedocuments").DataTable();
    table.columns.adjust().responsive.recalc();
  }

  hideFolderView() {
    document.getElementById("sidepanel").classList.add("d-none");
  }

  insertV10FoldersTemplate() {
    const foldersPanelTemplate = document.getElementById(
      "document-folders-panel-tpl",
    );
    if (foldersPanelTemplate) {
      document
        .getElementById("sidepanel")
        .replaceWith(foldersPanelTemplate.content.cloneNode(true));
    }
  }

  enableNewDocumentLink() {
    const newCorrespondenceItemLink = this.config.newCorrespondenceUrl;
    const newDocumentLinkElement = document.getElementById("filesNewDocument");
    if (newDocumentLinkElement) {
      setLink(newDocumentLinkElement, newCorrespondenceItemLink);
    }
  }

  // triggered by document filter dropdown keyword checkbox
  toggleKeywordSearch(e) {
    searchKeywords = e.target.checked;
    const column = this.dataTable.column("keywords:name");
    this.dataTable.cells(column.nodes()).invalidate();
    this.dataTable.draw();
  }

  // triggered by folders panel checkbox
  toggleFolders() {
    if (this.folderPanelVisible) {
      if (this.filterFolderId != null) {
        this.foldersOutlet.selectFolder(this.filterFolderId);
      }
      this.showTheFolderView();
    } else {
      this.foldersOutlet.selectNone();
      this.hideFolderView();
    }
    persistFolderState(
      this.caseIdValue,
      this.folderPanelVisible,
      this.filterFolderId,
    );
    this.refreshDataTableContent();
  }

  // triggered by folders:select event
  filterByFolder({ detail: { folderId } }) {
    this.filterFolderId = folderId;
    persistFolderState(
      this.caseIdValue,
      this.folderPanelVisible,
      this.filterFolderId,
    );
    this.refreshDataTableContent();
  }

  // triggered by document group filter buttons
  filter(event) {
    event.preventDefault();
    if (event.currentTarget.classList.contains("disabled")) {
      return;
    }
    if (event.params.filter) {
      this.setActiveFilter(event.currentTarget);
    } else if (event.target == this.attachmentsInputTarget) {
      persistAttachmentsVisible(this.caseIdValue, this.showAttachments);
    }
    this.refreshDataTableContent();
  }

  setActiveFilter(filterNode) {
    this.filterTargets.forEach((node) => {
      node
        .querySelector(".nav-link")
        .classList.toggle("active", node == filterNode);
    });
  }

  filterListWhenUploadingDocument() {
    this.refreshDataTableContent();
  }

  refreshDataTableContent() {
    let url = this.filterUrl();
    $.ajax({
      url,
      contentType: "application/json",
      dataType: "json",
      method: "GET",
      error: function (data) {
        console.log("Error! Could not retrieve the data.");
        $(".fooicon-loader").remove();
        $(".footable-loader").append("<p>Error retrieving documents</p>");
        return {};
      },
    }).then((data) => {
      if (data != null) {
        this.documents = data.documents;
        this.counts = data.counts;
        this.filterState = data.filter;
        this.config = data.config;
        this.links = data.links;
		this.allDocuments = data.documents;
		this.topLevelDocuments = data.documents.filter(d => !d.emailAttachment);
		this.attachmentsByTxn = this.indexAttachmentsByTransactionId(this.allDocuments);
        updateFilterCounts(this.counts, {
          filterTargets: this.filterTargets,
          attachmentsTarget: this.attachmentsTarget,
        });
		const enhancedThreadingEnabled = !!this.config?.useEnhancedEmailThreading;
		let topLevelDocs = null;

		if(enhancedThreadingEnabled){
			this.attachmentsByTxn = this.indexAttachmentsByTransactionId(this.documents);
			 topLevelDocs = data.documents.filter(d => !d.emailAttachment);			
		}

		
        let table = $("#casedocuments").DataTable();
        table.clear();
		this._inDatasetSwap = true;
        table.rows.add(enhancedThreadingEnabled ? topLevelDocs: data.documents).draw();
		this._inDatasetSwap = false; 
      } else {
        console.log("Error! Could not retrieve the data.");
        $(".fooicon-loader").remove();
        $(".footable-loader").append("<p>Error retrieving documents</p>");
      }
    });
  }

  filterUrl() {
    let url = null;
    if (!this.links) {
      url = this.showAttachments
        ? this.initialWithAttachmentsUrlValue
        : this.initialUrlValue;
    } else {
      let key = this.activeFilter;
      if (key == "") {
        if (this.showAttachments) {
          key = "WithAttachments";
        }
      } else if (!this.showAttachments) {
        key = key + "WithoutAttachments";
      }
      url = this.links[key];
    }
    if (this.folderPanelVisible && this.filterFolderId != null) {
      url = new URL(url);
      url.searchParams.set("_folder_id", this.filterFolderId);
      url = url.toString();
    }
    return url;
  }

  get activeFilter() {
    const active = this.filterTargets.find((e) =>
      e.querySelector(".nav-link").classList.contains("active"),
    );
    let filter = active.dataset.documentListFilterParam;
    if (filter == "all") {
      filter = "";
    }
    return filter;
  }

  get showAttachments() {
    return this.attachmentsInputTarget.checked;
  }

  get folderPanelVisible() {
    return this.filterFolderInputTarget.checked;
  }

  makePublicColumnVisible() {
    if (!this.config) {
      return;
    }

    const publicColumn = this.dataTable.column("public:name");
    const publicColumnIndex = publicColumn.index();

    const forceShowPublicColumn =
      this.config.showPublicDocumentColumn === true ||
      this.config.showPublicDocumentColumn === "true";

    // If configured to force-show, only affect the current table display.
    // Do not read, modify, or save DataTables state.
	if (forceShowPublicColumn) {
	  publicColumn.visible(true, false);
	  this.dataTable.columns.adjust().draw(false);
	  return;
	}

    const savedState = this.dataTable.state.loaded();
    const publicColumnWasVisible = savedState
      ? savedState.columns[publicColumnIndex].visible
      : false;

    if (this.config.allowPublishedDocuments) {
      publicColumn.visible(publicColumnWasVisible);
    } else {
      publicColumn.visible(false);
      this.dataTable.button(`[data-cv-idx='${publicColumnIndex}']`).remove();
    }
  }

  filterByCategory(e) {
    this.dataTable
      .column("category:name")
      .search(e.target.value, {
        exact: true,
      })
      .draw();
  }

  updateCategoryFilterList() {
    let dropdownOptions = document.getElementById("categoryList");
    const baseUrl = `${this.config.baseURL}internal/category`.replace(
      "/servlet",
      "",
    );

    fetch(`${baseUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(
        `authId=${this.config.securityId}&customerCode=${this.config.codeType}`,
      ),
    })
      .then((response) => response.json())
      .then((data) => {
        let categorySearch = this.dataTable.column("category:name").search();
        data.forEach((category) => {
          let opt = document.createElement("option");
          opt.text = category.categoryName;
          opt.selected = categorySearch === category.categoryName;
          dropdownOptions.add(opt, null);
        });
      });
  }
  
  
  indexAttachmentsByTransactionId(documents) {
    return (documents || []).reduce((acc, d) => {
      if (d.emailAttachment) {
        (acc[d.transactionId] ||= []).push(d);
      }
      return acc;
    }, {});
  }

  bindAttachmentChildRowHandlers() {
    // Cache tbody since all handlers are delegated from the same element
    const $tbody = $('#casedocuments tbody');

    //Toggle attachments child row (expand/collapse) from the chevron button
    // Use delegated binding so it works for rows added/redrawn by DataTables.
    $tbody
      .off('click', 'td.attachment-details-control .attachment-toggle')
      .on('click', 'td.attachment-details-control .attachment-toggle', (e) => {
        // Prevent the click from triggering other row-level handlers (select, drag, etc.)
        e.preventDefault();
        e.stopPropagation();

        // Find the DataTables parent row from the clicked element
        const tr = $(e.currentTarget).closest('tr');
        const row = this.dataTable.row(tr);
        const parent = row.data();

        // Look up attachments for this email using the precomputed map by transactionId
        const children = this.attachmentsByTxn?.[parent.transactionId] || [];
        if (!children.length) return;

        // Button + icon elements (used to toggle chevron direction + aria state)
        const btn = e.currentTarget;
        const icon = btn.querySelector('i');

        // Collapse if already open
        if (row.child.isShown()) {
          row.child.hide();                   
          tr.removeClass('attachments-open');            
          btn.setAttribute('aria-expanded', 'false');

         // row.deselect();  

          // Switch chevron icon back to "right"
          icon.classList.remove('fa-angle-down');
          icon.classList.add('fa-angle-right');
        } else {
          // Expand: render attachment grid HTML and show it as a DataTables child row
          row.child(this.formatAttachments(children)).show();
          tr.addClass('attachments-open');
          btn.setAttribute('aria-expanded', 'true');

         // row.select();        

          // Switch chevron icon to "down"
          icon.classList.remove('fa-angle-right');
          icon.classList.add('fa-angle-down');
        }
      });

    // Open the context menu for an attachment from the 3 dots inside the  grid
    // This is needed because the attachment are not real DataTables rows.
    $tbody
      .off('click', '.attachment-menu-btn')
      .on('click', '.attachment-menu-btn', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // We embed doc-<id> on the menu button when building the attachment grid HTML
        const idParam = e.currentTarget.dataset.documentListIdParam;
        const clickedDocumentId = this.documentIdFromParam(idParam);

        // Show the existing single-document menu for the attachment document
        this.documentMenuOutlet.singleDocument(
          this.documentById(clickedDocumentId),
          this.config
        );
        this.documentMenuOutlet.showNearEventPoint(e, e.timeStamp);
      });

    // Right-click anywhere on an attachment “row/card” to open the same menu
    $tbody
      .off('contextmenu', '.attachment-card')
      .on('contextmenu', '.attachment-card', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // We embed doc-<id> on the attachment wrapper (different data attribute)
        const idParam = e.currentTarget.dataset.attachmentDocIdParam;
        const clickedDocumentId = this.documentIdFromParam(idParam);

        this.documentMenuOutlet.singleDocument(
          this.documentById(clickedDocumentId),
          this.config
        );
        this.documentMenuOutlet.showNearEventPoint(e, e.timeStamp);
      });
  }

  formatAttachments(children, term = "") {
    const q = (term || "").trim().toLowerCase();

    const cards = (children || []).map((doc) => {
      const idParam = this.documentIdToParam(doc.documentId);

      const isMatch = q && this.rowSearchText(doc).includes(q);
      const matchClass = isMatch ? "attachment-card--match" : "";

      return `
        <div class="attachment-card ${matchClass}" data-attachment-doc-id-param="${idParam}">
          <div class="attachment-card__top">
            <div class="attachment-card__title">
              <i class="fa ${safeCssClass(doc.iconClass)}" aria-hidden="true"></i>
              <span class="attachment-card__name truncate" title="${doc.documentName || ""}">
                ${htmlEscape(doc.documentName) || ""}
              </span>
            </div>

            <button type="button"
              class="btn btn-sm documents-tbl-action-btn enable-tooltip attachment-menu-btn"
              title="Menu"
              data-controller="tooltip"
              data-tooltip-placement-value="top"
              data-tooltip-boundary-value="viewport"
              data-tooltip-selector-value=".enable-tooltip"
              data-document-list-id-param="${idParam}">
              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
              <span class="sr-only">Menu</span>
            </button>
          </div>

          <div class="attachment-card__bottom">
            <span class="attachment-card__size">${this.formatBytes(doc.fileSize)}</span>
          </div>
        </div>
      `;
    }).join("");

    const count = (children || []).length;

    return `
      <div class="attachment-child-wrapper">
        <div class="attachment-child-header">
          <i class="fa-solid fa-paperclip"></i> Attachments (${count})
        </div>
        <div class="attachment-grid">
          ${cards}
        </div>
      </div>
    `;
  }
  
  formatBytes(bytes) {
     const n = Number(bytes);
     if (!Number.isFinite(n) || n <= 0) return "";

     const units = ["B", "KB", "MB", "GB", "TB"];
     const i = Math.min(Math.floor(Math.log(n) / Math.log(1024)), units.length - 1);
     const value = n / Math.pow(1024, i);

     return `${value.toFixed(value >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
   }
   
  
   rowSearchText(row) {
     return [
       row?.documentName,
       row?.documentType,
       row?.category,
       searchKeywords ? row?.keywords : null,
       row?.notes,
       ...(row?.tags || []),
     ]
       .filter(Boolean)
       .join(" ")
       .toLowerCase();
   }

   isEmailRow(row) {
     return !!(row?.email || row?.emailBody);
   }

   isAttachmentRow(row) {
     return !!row?.emailAttachment;
   }
   
    bindHybridSearchMode() {
        if (this._hybridSearchBound) return;
        this._hybridSearchBound = true;

        this._inDatasetSwap = false;
        this._showingSearchResults = false;
        this._currentSearchTerm = "";

        // Expand matching emails after a draw (only in search mode)
        const controller = this;

        this.dataTable.on("draw.dt", function() {
            if (!controller.config?.useEnhancedEmailThreading) return;
            if (!controller._showingSearchResults) return;

            const term = (controller._currentSearchTerm || "").trim().toLowerCase();
            if (!term) return;

            controller.dataTable.rows({ page: "current" }).every(function() {
                const row = this;
                const parent = row.data();
                if (!parent?.__matchedByAttachment) return;

                const allChildren = controller.attachmentsByTxn?.[parent.transactionId] || [];
                if (!allChildren.length) return;

                // Expand the row with the all attachments showing
                row.child(controller.formatAttachments(allChildren, term)).show();
                const tr = row.node();
                tr.classList.add("attachments-open");

                const btn = tr.querySelector("td.attachment-details-control .attachment-toggle");
                const icon = btn?.querySelector("i");
                btn?.setAttribute("aria-expanded", "true");
                icon?.classList.remove("fa-angle-right");
                icon?.classList.add("fa-angle-down");
            });
        });

        // DataTables search box changes
        this.dataTable.on("search.dt", () => {
            if (this._inDatasetSwap) return;
            if (!this.config?.useEnhancedEmailThreading) return;
            if (!this.allDocuments || !this.topLevelDocuments) return;

            const term = (this.dataTable.search() || "").trim().toLowerCase();
            const shouldShowSearchResults = term.length > 1;
            this._currentSearchTerm = term;
           

            // Build the dataset we want to show
            let rows;

            if (!shouldShowSearchResults) {
                // Restore normal view: top-level docs only (emails + other docs), no attachment rows
                rows = this.topLevelDocuments;
            } else {
                // Attachment hits
                const attachmentHits = this.allDocuments.filter(d =>
                    d.emailAttachment && this.rowSearchText(d).includes(term)
                );
                const txnsWithAttachmentHits = new Set(attachmentHits.map(a => a.transactionId));

                // Emails that match themselves
                const emailHits = this.topLevelDocuments.filter(d =>
                    this.isEmailRow(d) && this.rowSearchText(d).includes(term)
                );

                // Emails that match because one of their attachments matched
                const emailsViaAttachments = this.topLevelDocuments
                    .filter(d => this.isEmailRow(d) && txnsWithAttachmentHits.has(d.transactionId))
                    .map(d => ({ ...d, __matchedByAttachment: true, __autoExpand: true }));

                // Other non-email, non-attachment top-level docs that match (PDFs, Word, etc.)
                const otherTopLevelHits = this.topLevelDocuments.filter(d =>
                    !this.isEmailRow(d) && this.rowSearchText(d).includes(term)
                );

                // Combine + dedupe by documentId
                const combined = [...emailsViaAttachments, ...emailHits, ...otherTopLevelHits];
                const seen = new Set();
                rows = combined.filter(r => {
                    const id = r?.documentId;
                    if (!id) return true;
                    if (seen.has(id)) return false;
                    seen.add(id);
                    return true;
                });
            }

            // Swap dataset
            this._inDatasetSwap = true;
            try {
                this._showingSearchResults = shouldShowSearchResults;
                this._currentSearchTerm = term;

                // Prevent DataTables applying its own search on top of our custom dataset
                this.dataTable.search("");

                this.dataTable.clear();
                this.dataTable.rows.add(rows).draw();
            } finally {
                this._inDatasetSwap = false;
            }
        });
    }
   
}
